module.exports = __webpack_public_path__ + "img/background.f0b45664.jpg";